import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ActivityDTO } from './activity.dto';

export class ActivityResponseModel extends GlobalResponseObject {
    data?: ActivityDTO;
    response: ActivityDTO[];
}
